import {
    Backdrop,
    Button,
} from "@mui/material";
import styled, { css, keyframes } from "styled-components";

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translate(-50%, -60%);
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%);
    }
`;

const fadeOut = keyframes`
    from {
        opacity: 1;
        transform: translate(-50%, -50%);
    }
    to {
        opacity: 0;
        transform: translate(-50%, -60%);
    }
`;

export const ModalWrapper = styled.div<{ isOpen: boolean }>`
    padding: 32px;
    max-width: 80vw;
    width: 600px;
    min-height: 400px;
    max-height: 80vh;
    border-radius: 12px;
    background-color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 32px;
    font-family: Noto Sans;
    opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
    animation: ${({ isOpen }) =>
    isOpen
        ? css`
                  ${fadeIn} 0.3s ease-out forwards
              `
        : css`
                  ${fadeOut} 0.3s ease-out forwards
              `};
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

export const Expandable = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 24px;
    border-bottom: 1px solid #eee;
`;

export const TitleText = styled.div`
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    color: #000;
`;

export const InfoText = styled.div`
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    color: #333;
`;

export const ProductList = styled.div`
    max-height: 400px;
    overflow-y: auto;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #e0e0e0;
`;

export const ProductItem = styled.div`
    padding: 16px;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: background-color 0.2s;

    &:hover {
        background-color: #f5f5f5;
    }

    &:last-child {
        border-bottom: none;
    }
`;

export const ProductName = styled.div`
    font-size: 16px;
    color: #000;
    font-weight: 600;
`;

export const QuantityInput = styled.input`
    width: 120px;
    height: 40px;
    padding: 0 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 16px;
    color: #000;
    font-weight: 500;

    &:focus {
        outline: none;
        border-color: #1976d2;
        box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);
    }

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

export const ButtonRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 24px;
    padding-top: 24px;
    border-top: 1px solid #eee;
`;

export const StyledButton = styled(Button)`
    && {
        min-width: 120px;
        height: 48px;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        border-radius: 8px;
        text-transform: none;
        box-shadow: none;

        &:hover {
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
    }
`;

export const StyledBackdrop = styled(Backdrop)`
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
`; 